// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.sparkline[data-v-89946f58] {\n  padding: 1rem 0.5rem;\n}\nsvg[data-v-89946f58] {\n  stroke: #000;\n  transition: all 1s ease-in-out;\n}\nsvg path[data-v-89946f58] {\n  box-sizing: border-box;\n}\n", ""]);
// Exports
module.exports = exports;
